<template>
    <div class="grin-container">
        <g-level>
            <g-level-item>
                <div>
                    <g-typography tag="h1" font-weight="semibold">
                        {{ title }}
                    </g-typography>
                </div>
            </g-level-item>
            <template #right>
                <g-button
                    v-if="!hideCloseButton"
                    shape="circle"
                    icon="times"
                    theme="live"
                    size="large"
                    data-testid="page-title-close-button"
                    @click="$emit('on-close')"
                />
            </template>
        </g-level>
    </div>
</template>

<script>
    export default {
        name: 'PageTitle',
        props: {
            title: {
                type: String,
                required: true
            },
            hideCloseButton: {
                type: Boolean,
                required: false,
                default: false
            }
        }
    };
</script>

<style lang="scss" scoped>
    .grin-container {
        background-color: $g-color-grey-3;
        padding: $g-spacing-6;
        margin: -$g-spacing-6;
    }
</style>
